import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import CompanyProfileSidebar from './CompanyProfileSidebar';
import { useVendorAuth } from '../../contexts/VendorAuthContext';
import { vendorProfileService, VendorProfile } from '../../services/vendorProfileService';

const VendorPortalLayout: React.FC = () => {
  const { vendor: sessionVendor } = useVendorAuth();
  const [vendorProfile, setVendorProfile] = useState<VendorProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchVendorProfile = async () => {
      if (!sessionVendor?.vendorId) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await vendorProfileService.getVendorProfile(sessionVendor.vendorId);
        if (response.success && response.vendor) {
          setVendorProfile(response.vendor);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading vendor profile for layout:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVendorProfile();
  }, [sessionVendor?.vendorId]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          minHeight: '100vh',
          width: '100%',
          bgcolor: '#ffffff',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress sx={{ color: '#67314f' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%', backgroundColor: '#ffffff' }}>
      <CompanyProfileSidebar vendorProfile={vendorProfile ?? undefined} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          minHeight: '100vh',
          backgroundColor: '#ffffff',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default VendorPortalLayout;

